import {useEffect, useState} from 'react';
import {Link, NavLink, Outlet, useNavigate} from 'react-router-dom';
import {Icon} from './Icon.jsx';
import {useCart} from '../store/CartContext.jsx';
import {useAuth} from '../store/AuthContext.jsx';

const nav = [['/', 'Home'], ['/catalog', 'Products'], ['/shops', 'Store'], ['/brands', 'Brand'], ['/categories', 'Categories']];
const categories = ['Fashion', 'Electronics', 'Home Decor', 'Appliances', 'Travel', 'Beauty & Health', 'Toys', 'Grocery', 'Mobile'];

function Hamburger() {
  return <svg viewBox="0 0 24 18" width="24" height="18" aria-hidden="true"><circle cx="2" cy="2" r="2" fill="currentColor"/><circle cx="2" cy="9" r="2" fill="currentColor"/><circle cx="2" cy="16" r="2" fill="currentColor"/><rect x="7" y="0.5" width="16" height="3" rx="1.5" fill="currentColor"/><rect x="7" y="7.5" width="16" height="3" rx="1.5" fill="currentColor"/><rect x="7" y="14.5" width="16" height="3" rx="1.5" fill="currentColor"/></svg>;
}

function CategoryFlyout({open, onClose}) {
  return <div className={`categorie-menu ${open ? 'sg-active' : ''}`}>{categories.map(category =>
    <Link key={category} to={`/catalog?category=${category.toLowerCase().replaceAll(' ', '-')}`} onClick={onClose}>{category}<span className="icon">›</span></Link>)}
    <Link className="last-menu-item" to="/categories" onClick={onClose}>View All Categories<span className="icon">›</span></Link>
  </div>;
}

export function AppShell() {
  const [drawer, setDrawer] = useState(false);
  const [flyout, setFlyout] = useState(false);
  const [stuck, setStuck] = useState(false);
  const [query, setQuery] = useState('');
  const navigate = useNavigate();
  const {count} = useCart();
  const {user} = useAuth();
  const seller = user?.roles?.some(role => role.slug === 'seller');
  useEffect(() => {
    const onScroll = () => setStuck(window.scrollY > 160);
    window.addEventListener('scroll', onScroll, {passive: true});
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  function search(event) { event.preventDefault(); navigate(`/catalog?q=${encodeURIComponent(query)}`); }
  return <div className="app">
    <a className="skip-link" href="#main">Skip to content</a>
    <header className="sg-header home-4">
      <div className="sg-topbar">
        <div className="shell topbar-content">
          <ul className="left-content">
            <li><a href="#play-store"><Icon name="grid"/> Play Store</a></li>
            <li><a href="#app-store"><Icon name="grid"/> App Store</a></li>
            {!seller ? <li><Link to="/account">Be a Seller</Link></li> : null}
            <li><Link to="/affiliate">Affiliate Program</Link></li>
          </ul>
          <ul className="right-content new-list">
            <li><a href="tel:+8801679575828"><strong>Call: +880 1679 575828</strong></a></li>
            <li><Link to="/track-order">Track Order</Link></li>
            <li><Link to="/compare-list">Compare</Link></li>
            <li><Link to="/blogs">Blog</Link></li>
          </ul>
        </div>
      </div>
      <div className="header-middle">
        <div className="shell botom-content">
          <div className="sg-logo"><Link className="logo" to="/">yoori<span>.</span></Link></div>
          <div className="sg-search">
            <form className="search-form" onSubmit={search}>
              <input value={query} onChange={event => setQuery(event.target.value)} placeholder="Search products, brands and more" aria-label="Search products"/>
              <button className="search_btn" aria-label="Search"><Icon name="search"/></button>
            </form>
          </div>
          <div className="user-option">
            <ul>
              <li><Link to="/wishlist" aria-label="Wishlist"><span className="icon"><Icon name="heart"/></span></Link></li>
              <li className="cart"><Link to="/cart" aria-label="Cart"><span className="icon"><Icon name="bag"/>{count ? <b className="badge">{count}</b> : null}</span></Link></li>
              <li className="user-log-info">
                <Link className="icon" to="/account" aria-label="Your account"><Icon name="user"/></Link>
                <span className="log-links">
                  {user
                    ? <><Link to="/account">Profile</Link><Link to="/account">Dashboard</Link></>
                    : <><Link to="/account">Sign in</Link><Link to="/register">Register</Link></>}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className={`header-menu ${stuck ? 'fixed-top' : ''}`} id="nav">
        <div className="shell bottom-content">
          <div className="sg-categorie-menu categorie-lg">
            <button className="top-content" onClick={() => setFlyout(open => !open)} aria-expanded={flyout}>
              <span className="sg-toggle"><Hamburger/></span>
              <span>All Categories</span>
            </button>
            <CategoryFlyout open={flyout} onClose={() => setFlyout(false)}/>
          </div>
          <div className="right-content">
            <nav className="sg-menu">
              {nav.map(([to, label]) => <NavLink key={to} to={to}>{label}</NavLink>)}
              {seller ? <NavLink to="/seller">Seller Portal</NavLink> : null}
            </nav>
            <div className="offer">
              <Link to="/daily-deals"><Icon name="filter"/> Daily Deals</Link>
            </div>
          </div>
        </div>
      </div>
    </header>
    <main id="main"><Outlet/></main><Footer seller={seller}/>
    <nav className="sticky-sm-menu">
      <ul>
        <li><button onClick={() => setDrawer(true)} aria-label="Menu"><Icon name="menu"/><span>Menu</span></button></li>
        <li><NavLink to="/"><Icon name="home"/><span>Home</span></NavLink></li>
        <li><button onClick={() => setDrawer(true)} aria-label="Categories"><Icon name="grid"/><span>Category</span></button></li>
        <li><NavLink to="/cart"><Icon name="bag"/><span>Cart</span></NavLink></li>
        <li><NavLink to="/account"><Icon name="user"/><span>{user ? 'Account' : 'Login'}</span></NavLink></li>
      </ul>
    </nav>
    <div className={`drawer-scrim ${drawer ? 'open' : ''}`} onClick={() => setDrawer(false)}/><aside className={`drawer ${drawer ? 'open' : ''}`}><button className="drawer-close" onClick={() => setDrawer(false)}>×</button><h2>All Categories</h2>{categories.map(category => <Link key={category} to={`/catalog?category=${category.toLowerCase().replaceAll(' ', '-')}`} onClick={() => setDrawer(false)}>{category}<Icon name="chevron"/></Link>)}<Link className="drawer-view-all" to="/categories" onClick={() => setDrawer(false)}>View All Categories ›</Link></aside>
  </div>;
}

const payments = ['VISA', 'Mastercard', 'Amex', 'PayPal'];

function Footer({seller}) {
  return <footer className="footer-section">
    <div className="shell footer-top">
      <div className="footer-logo"><Link className="logo inverse" to="/">yoori<span>.</span></Link></div>
      <div className="footer-columns">
        {!seller ? <div className="footer-widget"><h3>Seller Options</h3><ul><li><Link to="/account">Login as Seller</Link></li><li><Link to="/account">Signup as Seller</Link></li></ul></div> : null}
        <div className="footer-widget"><h3>My Account</h3><ul><li><Link to="/account">My Profile</Link></li><li><Link to="/user/orders">Order History</Link></li><li><Link to="/wishlist">My Wishlist</Link></li><li><Link to="/track-order">Track Order</Link></li></ul></div>
        <div className="footer-widget"><h3>Useful Links</h3><ul><li><Link to="/blogs">Blog</Link></li><li><Link to="/campaigns">Campaigns</Link></li><li><Link to="/support">Support Center</Link></li><li><Link to="/affiliate">Affiliate Program</Link></li></ul></div>
        <div className="footer-widget address"><h3>Contact Us</h3><ul>
          <li><h4>Address</h4><span>Dhaka, Bangladesh</span></li>
          <li><h4>Email</h4><a href="mailto:hello@yoori.com">hello@yoori.com</a></li>
          <li><h4>Phone</h4><a href="tel:+8801679575828">+880 1679 575828</a></li>
        </ul></div>
        <div className="footer-widget about"><h3>About</h3><p>Modern essentials, selected with care and delivered reliably to your door.</p>
          <div className="footer-social-icons">{['f', 't', 'in', 'ig', 'yt'].map(social => <a key={social} href={`#${social}`} aria-label={social}>{social}</a>)}</div>
        </div>
      </div>
    </div>
    <div className="footer-bottom"><div className="shell footer-bottom-content">
      <p className="copyright">© {new Date().getFullYear()} Yoori Commerce. All rights reserved.</p>
      <ul className="payment-card">{payments.map(payment => <li key={payment}>{payment}</li>)}</ul>
    </div></div>
  </footer>;
}
